import initAccordion from "../../common/accordion.js";

export default () => {
  document.querySelectorAll(".js-accordion-horizontal").forEach((el, i) => {
    let activeIndex = 0;

    const accordions = [...el.querySelectorAll(".js-accordion")].map(
      (el, index) => {
        el.querySelector(".js-accordion-link").addEventListener(
          "click",
          (e) => {
            activeIndex = index;

            accordions.forEach((accordion, i) => {
              if (i !== activeIndex) {
                accordion.toggleContent(false);
              }
            });
          },
        );

        return initAccordion(el, index);
      },
    );
  });
};
